import type { AppRole } from '@/types/domain';

export const rolePriority: readonly AppRole[] = ['owner', 'admin', 'officer', 'mass_manager', 'member'] as const;

export function getPrimaryRole(roles: AppRole[]): AppRole {
  return rolePriority.find((role) => roles.includes(role)) ?? 'member';
}

export function formatAppRoleLabel(role: AppRole): string {
  if (role === 'mass_manager') {
    return 'Mass Manager';
  }

  if (role === 'owner') {
    return 'Owner';
  }

  return role[0].toUpperCase() + role.slice(1);
}
